<template>
  <div>
    <div class="uk-child-width-1-2" uk-grid>
      <div>
        <div class="uk-inline uk-width-1-1 uk-flex uk-flex-center">
          <span class="uk-form-icon" uk-icon="icon: search"></span>
          <input
            class="uk-input uk-width-1-1"
            type="text"
            v-model="search"
            placeholder="Search Colors"
          />
        </div>
      </div>
      <div>
        <select class="uk-select" v-model="familySelect">
          <option>Show All Colors</option>
          <option>Red</option>
          <option>Orange</option>
          <option>Yellow</option>
          <option>Green</option>
          <option>Blue</option>
          <option>Purple</option>
          <option>Pink</option>
          <option>White/Off White</option>
          <option>Gray</option>
        </select>
      </div>
    </div>

    <div class="uk-child-width-1-3 uk-child-width-1-6@m" uk-grid>
      <div v-for="(color,index) in colors" v-show="color.show">
        <a href="#">
          <div
            class="uk-card uk-card-default uk-card-hover uk-card-small uk-margin-medium-bottom"
            id="card"
            v-on:click="selectColor(index)"
          >
            <div class="uk-card-media-top">
              <svg viewBox="0 0 100 52">
                <title>square</title>
                <rect width="100" height="52" v-bind:style="{ fill: color.hex }" />
              </svg>
            </div>
            <div class="uk-card-body">
              <p class="uk-margin-small uk-text-muted">{{color.colorName}}</p>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
//import ColorsService from "@/services/ColorsService";
import firebase from "firebase";

// function isKnotty(color){
// 	return color.colorSet == "Knotty"
// }

// const knottyColors = ColorsService.filter(isKnotty)

// for (const i of ColorsService) {
// 	i.show = true
// }

export default {
  name: "knottyColorSelect",

  data() {
    return {
      search: "",
      colors: [],
      colorFamily: "",
      familySelect: "Show All Colors"
    };
  },

  methods: {
    selectColor(colorIndex) {
      let color = this.colors[colorIndex];
      this.$emit("knottyColorSelected", color), (this.search = "");
    },
    clearSearch() {
      this.search = "";
      this.colorFamily = "";
      this.familySelect = "Show All Colors";
    },
    clearColorFilters() {
      this.colorFamily = "";
    }
  },

  computed: {
    searchFam() {
      return this.search + this.colorFamily;
    }
  },

  watch: {
    familySelect() {
      if (this.familySelect.indexOf("Show") > -1) {
        this.colorFamily = "";
      } else {
        this.colorFamily = this.familySelect;
      }
    },
    searchFam() {
      for (const i of this.colors) {
        if (
          i.colorName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 &&
          i.category.indexOf(this.colorFamily) > -1
        ) {
          i.show = true;
        } else {
          i.show = false;
        }
      }
    }
  },
  mounted: function() {
    var self = this;
    const colorsRef = firebase
      .firestore()
      .collection("colors")
      .doc("0");
    colorsRef
      .get()
      .then(function(doc) {
        if (doc.exists) {
          let c = doc.data();
          console.log(c["knotty-colors"]);
          for (const i of c["knotty-colors"]) {
            i.show = true;
          }
          function isKnotty(color) {
            return color.colorSet == "Knotty";
          }
          const knottyColors = c["knotty-colors"].filter(isKnotty);
          self.colors = knottyColors;
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/KnottyColorSelect.vue